/* eslint-disable consistent-return */
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { LenderEnum } from "models/inventory/enums/vehicle.enums";
import { VehiclesFilters } from "models/inventory/interfaces/vehicle.interface";
import { GET_VEHICLES } from "queries/getVehicles";

export const client = new ApolloClient({
  uri: `${process.env.REACT_APP_API_BASE_URL_PA}graphql`,
  cache: new InMemoryCache(),
});

export const fetchVehiclesGraphql = async (filters: Partial<VehiclesFilters>) => {
    try {
      const { data } = await client.query({
        query: GET_VEHICLES,
        variables: {
          status: "available",
          ...filters
        }
    });
      return data;
    } catch (error) {
      console.log(error);
    }
  };

export const fetchBodegaVehiclesGraphql = async (filters: Partial<VehiclesFilters>) => {
    try {
      const { data } = await client.query({
        query: GET_VEHICLES,
        variables: {
          ...filters,
          status: "available",
          lenders: [LenderEnum.Atrato, LenderEnum.Maxikash],
        }
    });
      return data;
    } catch (error) {
      console.log(error);
    }
  };
